import { render, staticRenderFns } from "./OnlineCultureCinema.vue?vue&type=template&id=54ec6968&"
import script from "./OnlineCultureCinema.vue?vue&type=script&lang=ts&"
export * from "./OnlineCultureCinema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports